<template>
  <success-page-layout store-badges-button-code="body-20210304-success-page-business" :promote-app-download="false">
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4 m:mb-6" v-html="$t('headline')" />

      <p v-html="$t('firstParagraphCop')" />

      <p v-html="$t('secondParagraphCopy')" />
    </template>

    <template v-slot:image>
      <confirm-email-image />
    </template>
  </success-page-layout>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import { getSearchParam } from "@/utils/location"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import ConfirmEmailImage from "@/pages/success-page/components/confirm-email/image"
import globals from "@/utils/globals"

export default {
  name: "TeamPurchaseSuccess",
  components: {
    ConfirmEmailImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    partnerPortalUrl() {
      return globals.routes.settingsPath
    },
    cancelNoteType() {
      return getSearchParam("cancelNote")
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Let’s confirm your email",
        firstParagraphCop:
          "You’re almost there! You can confirm your email address by clicking the button in the email we’ve just sent to you.",
        secondParagraphCopy: "Don’t forget to check your spam folder!"
      },
      de: {
        headline: "Bitte bestätige deine E-Mail-Adresse",
        firstParagraphCop:
          "Gleich kann’s losgehen! Bitte bestätige deine E-Mail-Adresse, indem du auf den Link in der E-Mail klickst, die wir dir gerade geschickt haben.",
        secondParagraphCopy: "Denk daran, auch deinen Spam-Ordner zu überprüfen."
      }
    }
  }
}
</script>
